import { Swiper, SwiperSlide } from 'swiper/react';
import { useTranslation } from 'react-i18next';

import 'swiper/css';

import serv1 from '../../../assets/assets-home/img/services/1.jpg';
import serv2 from '../../../assets/assets-home/img/services/2.jpg';
import serv3 from '../../../assets/assets-home/img/services/3.jpg';
import serv4 from '../../../assets/assets-home/img/services/4.png';
import serv5 from '../../../assets/assets-home/img/services/5.jpg';
import serv6 from '../../../assets/assets-home/img/services/6.jpg';
import serv7 from '../../../assets/assets-home/img/services/7.jpg';
import serv8 from '../../../assets/assets-home/img/services/8.jpg';

import SpeakToExpertButton from 'src/components/home/SpeakToExpertButton';

type Service = { id: number; image: string; titleKey: string };

const services: Service[] = [
  { id: 1, image: serv1, titleKey: 'services.items.hotel' },
  { id: 2, image: serv2, titleKey: 'services.items.villa' },
  { id: 3, image: serv3, titleKey: 'services.items.itineraries' },
  { id: 4, image: serv4, titleKey: 'services.items.group' },
  { id: 5, image: serv5, titleKey: 'services.items.jet' },
  { id: 6, image: serv6, titleKey: 'services.items.concierge' },
  { id: 7, image: serv7, titleKey: 'services.items.yacht' },
  { id: 8, image: serv8, titleKey: 'services.items.car' },
];

const ServiceCard = ({ service, className = '' }: { service: Service; className?: string }) => {
  const { t, i18n } = useTranslation('home');
  const title = t(service.titleKey);
  const isRu = i18n.language === 'ru';
  const displayTitle = isRu && title
    ? title.charAt(0).toUpperCase() + title.slice(1).toLowerCase()
    : title;
  return (
    <div className='lg:max-w-[262px] sm:max-w-[200px] max-w-[110px]'>
      <div className={`overflow-hidden ${className}`}>
        <img
          src={service.image}
          alt={displayTitle}
          className="w-full h-full object-cover"
        />
      </div>

      <h5 className={`whitespace-pre-line text-center font-medium text-black text-xs mt-5 sm:text-xl sm:mt-[37px] lg:text-2xl lg:mt-[37px] ${isRu ? '' : 'capitalize'}`}>
        {displayTitle}
      </h5>
    </div>
  );
};

const ServicesSlider = () => {
  const { t } = useTranslation('home');
  const { t: tCommon } = useTranslation('common');
  return (
    <div className='lg:py-[60px] sm:py-10 py-8' id="services">
      <h2 className="section-heading text-center mb-6 sm:mb-8 lg:mb-10 px-5 sm:px-6 lg:px-10">{t('services.heading')}</h2>

      <div className="hidden lg:block">
        <div className="w-fit grid grid-cols-4 gap-4 lg:gap-8 justify-center mx-auto">
          {services.map((service) => (
            <ServiceCard
              key={service.id}
              service={service}
              className="aspect-square max-w-[262px] rounded-[30px]"
            />
          ))}
        </div>
      </div>

      <div className="lg:hidden">
        <Swiper
          slidesPerView="auto"
          spaceBetween={16}
          slidesOffsetBefore={20}
          slidesOffsetAfter={20}
          breakpoints={{
            640: { spaceBetween: 20, slidesOffsetBefore: 24, slidesOffsetAfter: 24 },
          }}
          className="services-slider"
        >
          {services.map((service) => (
            <SwiperSlide key={service.id} style={{ width: 'auto' }}>
              <ServiceCard
                service={service}
                className="w-[110px] h-[110px] rounded-[12px] sm:w-[200px] sm:h-[200px] sm:rounded-[23px]"
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <p className="mt-5 sm:mt-8 lg:mt-[60px] text-center text-[10px] sm:text-base leading-[120%] text-[#4A4A4A]">
        <span className="text-[#7aa1c4] font-semibold">{tCommon('cta.gotSomethingElse.prefix')}</span> {tCommon('cta.gotSomethingElse.suffix')}
      </p>

      <div className="flex justify-center mt-6 md:mt-8">
        <SpeakToExpertButton />
        </div>
    </div>
  );
};

export default ServicesSlider;
